import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="about" data-testid="about-section" ref={ref} className="px-6 py-14 sm:px-12 sm:py-28 lg:px-20 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="flex items-center gap-4 font-accent text-[11px] font-semibold tracking-[0.35em] text-gold">
            <span className="h-px w-12 bg-gold" /> ABOUT
          </p>
          <h2 className="mt-6 font-display text-3xl font-normal leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            <span className="text-crimson">Growth</span> Centric,
            <br />
            <span className="text-crimson">People</span> <span className="italic">Driven.</span>
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
          <Reveal delay={0.15} className="relative overflow-hidden lg:col-span-5">
            <motion.img
              src="/shopfront.jpg"
              alt="Praveen Textiles shop front — Bothra Complex, Old Washermenpet, Chennai"
              style={{ y: imgY }}
              className="aspect-[4/5] w-full scale-[1.2] object-cover brightness-105"
            />
            <div className="absolute inset-0 border border-crimson/15" />
          </Reveal>
          <div className="lg:col-span-7">
            <Reveal>
              <p className="max-w-2xl text-base font-bold leading-relaxed text-ink">
                Praveen Textiles began in 1988, started by our grandfather, who borrowed goods
                from a family member to get the business off the ground. What started as a modest
                textile trading venture in Chennai was built on something simple: honest dealing
                and a genuine understanding of fabric and the people who work with it.
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-7 max-w-2xl text-base font-bold leading-relaxed text-ink">
                We started out of a small 200 sq ft shop — and over four decades, that humble
                beginning has grown into a multistory store known across Chennai for its range and
                reliability. Today, we deal in Handloom &amp; Home Furnishing, Blouse materials,
                Sarees, Shirting &amp; Suiting fabrics, and Uniform Fabrics — a variety built up
                section by section as we listened to what our customers needed. What began as a
                small operation now runs with a team of 20 employees, serving retailers and buyers
                who trust us for consistency, quality, and fair pricing.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-7 max-w-2xl text-base font-bold leading-relaxed text-ink">
                Now in its third generation, Praveen Textiles remains a family business at heart,
                still guided by the same principles our grandfather started with: trust, quality,
                and a genuine relationship with every buyer who walks through our door.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
